import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  UserFieldsListComponent,
  UserFieldFormComponent,
  UserFieldsReorderComponent
} from '../upgrade/user-fields.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard } from '@fry-it/risr-core';
import { forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const userFieldsRoutes: Routes = [
  {
    path: 'user-fields',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      permission: 'userFields.view'
    },
    children: [
      {
        path: '',
        component: UserFieldsListComponent,
        data: {
          state: 'epf.user-fields.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: UserFieldFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'userFields.edit',
          state: 'epf.user-fields.new'
        }
      },
      {
        path: 'edit/:id',
        component: UserFieldFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'userFields.edit',
          state: 'epf.user-fields.edit'
        }
      },
      {
        path: 'reorder',
        component: UserFieldsReorderComponent,
        canActivate: [authGuard, forceOnlineGuard],
        data: {
          permission: 'userFields.edit',
          state: 'epf.user-fields.reorder'
        }
      }
    ]
  }
];
